import { cn } from "@/lib/utils";
import { formatDateTime } from "@/lib/display-labels";
import type { InterpretationListItem } from "@/types/interpretation.types";

const KIND_LABEL: Record<string, string> = {
  RUN: "Rodada",
  COMPARISON: "Comparação",
  BATCH: "Busca automática",
};

// Histórico de leituras de uma rodada — cada item reabre a interpretação persistida (deep-link).
export function HistoryList({
  items,
  selectedId,
  onSelect,
}: {
  items: InterpretationListItem[];
  selectedId: string | undefined;
  onSelect: (id: string) => void;
}): React.ReactElement {
  return (
    <ul className="space-y-1">
      {items.map((it) => (
        <li key={it.id}>
          <button
            type="button"
            onClick={() => onSelect(it.id)}
            className={cn(
              "w-full rounded-md border px-3 py-2 text-left transition-colors",
              "focus-visible:shadow-rd-focus focus-visible:outline-none",
              it.id === selectedId
                ? "bg-brand-50/50 border-brand-400"
                : "border-border-subtle hover:bg-bg-muted-rd"
            )}
          >
            <p className="line-clamp-2 text-[12.5px] font-medium text-text-primary">
              {it.headline}
            </p>
            <p className="mt-0.5 text-[11px] text-muted-foreground">
              {KIND_LABEL[it.kind] ?? it.kind}
              {it.narrativeSource === "ASSISTANT" ? " · com análise IA" : ""} ·{" "}
              {formatDateTime(it.createdAt)}
            </p>
          </button>
        </li>
      ))}
    </ul>
  );
}
